import { h, Fragment } from "preact";
import ProductOptionSwatchesGrouped from "./product-option-swatches-grouped";
import ProductOptionSwatches from "./product-option-swatches";
import ProductOptionPills from "./product-option-pills";
import ProductOptionPillsInline from "./product-option-pills-inline";
import ProductOptionSwatchesInline from "./product-option-swatches-inline";

export default function ProductOption({
  option,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues,
  variantsByOptionValue,
  unavailableOptionValues,
  allowMaterialGroups,
  selectedIsHidden,
  selectedVariant,
  openByDefault,
  last,
  enableSwatchPreview,
  enableAccordions,
  disabledSwatchStyle,
  optionSize,
}) {
  const isSwatch = option.optionValues.some(
    (optionValue) => optionValue.swatch,
  );

  const showMaterialGroups =
    allowMaterialGroups &&
    option.optionValues.some((optionValue) => optionValue.materialGroup);

  const optionValues = option.optionValues.filter((optionValue) => {
    if (selectedIsHidden) {
      return optionValue.name === selectedOptionValue;
    }

    return !optionValue.allMatchingVariantsHidden;
  });

  if (enableAccordions) {
    if (isSwatch) {
      if (showMaterialGroups) {
        return (
          <ProductOptionSwatchesGrouped
            optionValues={optionValues}
            optionName={option.optionName}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            variantsByOptionValue={variantsByOptionValue}
            unavailableOptionValues={unavailableOptionValues}
            selectedVariant={selectedVariant}
            openByDefault={openByDefault}
            last={last}
            enableSwatchPreview={enableSwatchPreview}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
          />
        );
      } else {
        return (
          <ProductOptionSwatches
            optionValues={optionValues}
            optionName={option.optionName}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            variantsByOptionValue={variantsByOptionValue}
            unavailableOptionValues={unavailableOptionValues}
            selectedVariant={selectedVariant}
            openByDefault={openByDefault}
            last={last}
            enableSwatchPreview={enableSwatchPreview}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
          />
        );
      }
    }

    return (
      <ProductOptionPills
        optionValues={optionValues}
        optionName={option.optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        variantsByOptionValue={variantsByOptionValue}
        unavailableOptionValues={unavailableOptionValues}
        openByDefault={openByDefault}
        last={last}
        optionSize={optionSize}
      />
    );
  } else {
    if (isSwatch) {
      return (
        <ProductOptionSwatchesInline
          optionValues={optionValues}
          optionName={option.optionName}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          variantsByOptionValue={variantsByOptionValue}
          unavailableOptionValues={unavailableOptionValues}
          disabledSwatchStyle={disabledSwatchStyle}
          last={last}
          optionSize={optionSize}
        />
      );
    }

    return (
      <ProductOptionPillsInline
        optionValues={optionValues}
        optionName={option.optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        variantsByOptionValue={variantsByOptionValue}
        unavailableOptionValues={unavailableOptionValues}
        last={last}
        optionSize={optionSize}
      />
    );
  }
}
